module.exports = __webpack_public_path__ + "iphone_2x.a057f191349457f815e5aa9d98244d40.png";